import { render, staticRenderFns } from "./AccItem.vue?vue&type=template&id=6b4fef03&scoped=true"
import script from "./AccItem.vue?vue&type=script&lang=js"
export * from "./AccItem.vue?vue&type=script&lang=js"
import style0 from "./AccItem.vue?vue&type=style&index=0&id=6b4fef03&prod&lang=scss&scoped=true"
import style1 from "./AccItem.vue?vue&type=style&index=1&id=6b4fef03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4fef03",
  null
  
)

export default component.exports